import styled from 'styled-components';
import { colors } from '~/styles/colors';
import { Link } from 'react-router-dom';

export const ViewModeButton = styled.button<{ isActive: boolean }>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 32px;
  background-color: #ffffff;

  border: ${(props) => (props.isActive ? `2px solid ${colors.brand.principal}` : 0)};
  border-radius: 5px;

  font-size: 12px;
  font-weight: 600;
  color: ${(props) => (props.isActive ? colors.brand.principal : '#7A7A7A')};

  > span {
    margin-right: 4px;
  }

  & + & {
    margin-left: 10px;
  }

  transition: filter 0.3s;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  .input-container {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    max-width: fit-content;

    > div {
      height: 50px;
      min-width: 250px;
    }

    > div + div {
      height: 50px;
    }
  }
`;

export const Label = styled.span`
  transition: all 0.2s;
  margin-top: -6px;
  margin-left: 16px;
  margin-right: 16px;
  color: ${colors.Blue700};
  font-size: 11px;
  font-weight: bold;
`;

export const SearchInput = styled.div`
  min-height: 48px;
  max-width: 250px;
  margin: 0;
  font-size: 12px;
  color: #000;
  width: 100%;
  border: 1px solid #818181;
  border-radius: 5px;
  box-sizing: border-box !important;
  display: inline-flex;
`;

export const BtnClean = styled.div`
  cursor: pointer;
  color: ${colors.BlueSecondary};
  margin-top: 7px;
  text-decoration: underline;
  font-size: 11px;
`;

export const StyledSpan = styled.span`
  font-size: 1em;
  font-weight: bold;
  color: ${colors.Grey400};
`;

export const MosaicContainer = styled.div`
  display: flex;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top: none;
  min-height: 300px;
  gap: 15px;
  flex-wrap: wrap;
  overflow-y: auto;
`;

export const TransparentLink = styled(Link)`
  color: inherit;
  text-decoration: inherit;

  &:hover {
    color: inherit;
    text-decoration: inherit;
  }
`;

export const TableItemCell = styled.div`
  font-size: 12.6px;
  margin: 5px 0;
`;

export const StyledItem = styled.li<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  white-space: nowrap;
  gap: 5px;
  cursor: pointer;

  span {
    padding: 0 14px;
    color: ${({ isActive }) => (isActive ? colors.brand.principal : colors.text['sub-500'])};
    font-weight: 600;
  }

  span:hover {
    color: ${colors.brand.principal};
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
`;

export const PageButton = styled.button<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  border: ${({ active }) => (active ? 'none' : '1px solid #ccc')};
  background-color: ${({ active }) => (active ? colors.brand.principal : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#2c2c2c')};
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const PageButtonArrow = styled.button<{ active?: boolean }>`
  width: 32px;
  height: 32px;
  border: none;
  background-color: ${({ active }) => (active ? colors.text['sub-500'] : '#fff')};
  color: ${({ active }) => (active ? '#fff' : colors.text['sub-500'])};
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;
